// extracted by mini-css-extract-plugin
export default {"content":"FinancialTransactionsReport_content__tuHET"};